"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnackBox = void 0;
var React = require("react");
var theme_1 = require("../../utils/theme");
var ApIcon_1 = require("../ApIcon");
var styles_1 = require("./styles");
var constants_1 = require("./constants");
var utils_1 = require("./utils");
exports.SnackBox = function (_a) {
    var hide = _a.hide, id = _a.id, variant = _a.variant, message = _a.message, custom = _a.custom, button = _a.button, showIcon = _a.showIcon;
    var hideById = function () {
        if (id && hide) {
            hide(id);
        }
    };
    return (React.createElement(React.Fragment, null,
        message && (React.createElement(styles_1.StyledSnackBox, { className: "" + constants_1.SNACK_CLASS_NAME, variant: variant },
            React.createElement(styles_1.StyledSnackMessage, null,
                showIcon && (React.createElement(ApIcon_1.ApIcon, { iconName: utils_1.getIcon(variant).name, iconColor: theme_1.colors.white })),
                message),
            button && React.createElement(styles_1.StyledSnackButton, null, button()))),
        custom && (React.createElement(styles_1.StyledSnackBoxCustom, { id: id }, custom(hideById)))));
};
//# sourceMappingURL=ApSnackBox.js.map